import React, { useEffect } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';

import logEvent from 'analytics/logEvent';

import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';

import pagesUrls from 'constants/pagesUrls';

import ALink from 'components/basic/ALink';
import { BodyL, Factoid, H3 } from 'components/basic/Typography';
import LinkList from 'components/complex/_errors/LinkList';
import s from 'components/complex/_errors/error.module.scss';
import Page from 'components/layouts/Page';

const Page404: React.FC = () => {
  const router = useRouter();
  const t = useTranslationAndTypograph();

  useEffect(() => {
    let pageNotFoundPath = router.asPath;
    pageNotFoundPath = pageNotFoundPath.startsWith('/') ? pageNotFoundPath : `/${pageNotFoundPath}`;
    const segments = pageNotFoundPath.split('/');
    const eventProperties = {
      fullPath: router.asPath,
      path: segments[1]
    };
    logEvent('Web_404_Page_Viewed', eventProperties);
  }, [router]);

  return (
    <Page fullHeight>
      <div className={s.wrapper}>
        <div className={s.textWrapper}>
          <Factoid className={s.factoid}>404</Factoid>

          <H3 className={s.bodyL}>{t('Looks like we can’t find this page')}</H3>

          <BodyL className={s.message}>
            {t('Take a deep breath and head')}{' '}
            <ALink
              className={s.messageLink}
              href={pagesUrls.plans}
              onClick={(): void => {
                logEvent('Web_404_Page_Link_Clicked', {
                  link_id: 'homepage',
                });
              }}
            >
              {t('to our homepage')}
            </ALink>
            , {t('or check out other spaces')}
          </BodyL>
          <LinkList eventName="Web_404_Page_Link_Clicked" />
        </div>
        <div className={s.image}>
          <Image src="/pagesImages/404/error404.gif" width="472" height="472" />
        </div>
      </div>
    </Page>
  );
};

export default Page404;
